<template>
    <div>
        <div class="d-flex justify-content-end">
            <button
                @click="onClickToPrintSummary"
                class="btn btn-outline-secondary btn-sm waves-effect"
            >
                <i class="fas fa-print me-25"></i> Print
            </button>
        </div>

        <div class="row summary-row mb-1">
            <div v-for="(tile, i) in kpiTiles" :key="i" class="col-md-2 col-sm-4 col-6 summary-row-item">
                <div class="stat-tile" :class="tile.borderClass">
                    <div class="stat-icon-badge" :class="tile.borderClass">
                        <i class="fas" :class="tile.icon"></i>
                    </div>
                    <p class="stat-label">{{ tile.name }}</p>
                    <h4 class="stat-value">{{ tile.value }}</h4>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-9 col-12">
                <div class="card general-card section-card section-card-customer mb-1">
                    <div class="card-body py-1 px-1">
                        <h6 class="card-section-title">Customer Information</h6>
                        <div class="row">
                            <div class="col-md-6 col-12">
                                <p v-if="contactName" class="mb-25">Customer Name: {{ contactName }}</p>
                                <p v-if="summary.contact_person" class="mb-25">Contact Person: {{ summary.contact_person }}</p>
                                <p v-if="contactAddress" class="mb-0">Address: {{ contactAddress }}</p>
                            </div>
                            <div class="col-md-6 col-12">
                                <p v-if="summary.contact_phone_numbers" class="mb-25">Mobile: {{ summary.contact_phone_numbers }}</p>
                                <p v-if="summary.currency" class="mb-0">Currency: {{ summary.currency }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card general-card section-card section-card-items">
                    <div class="card-body py-1 px-1">
                        <div class="order-meta-row">
                            <div class="meta-chip">
                                <span class="meta-chip-label">Bill No</span>
                                <span class="meta-chip-value">{{ summary.bill_number }}</span>
                            </div>
                            <div class="meta-chip">
                                <span class="meta-chip-label">Date</span>
                                <span class="meta-chip-value">{{ readableDate(summary.date) }}</span>
                            </div>
                            <div class="meta-divider"></div>
                            <div class="meta-chip">
                                <span class="meta-chip-label">Status</span>
                                <span class="status-badge" :style="badgeStyle(summary.status)">{{ convertToTitleCase(summary.status) }}</span>
                            </div>
                            <div class="meta-chip">
                                <span class="meta-chip-label">Payment</span>
                                <span class="status-badge" :style="badgeStyle(summary.payment_status)">{{ convertToTitleCase(summary.payment_status) }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered custom-table-padding">
                            <thead>
                                <tr>
                                    <th>Item Details</th>
                                    <th class="text-right">PI Qty</th>
                                    <th>Production Qty</th>
                                    <th>Delivery Qty</th>
                                    <th class="text-right">Unit Price</th>
                                    <th class="text-right">Total Amount</th>
                                    <th>Costing</th>
                                    <th>Production</th>
                                    <th>Delivery</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in lineItems" :key="i">
                                    <td>{{ item.product_name }}</td>
                                    <td class="text-right">{{ item.quantity }}</td>
                                    <td>
                                        <div>{{ item.total_pq }}</div> 
                                    </td>
                                    <td>
                                        <div>{{ item.total_del_qty }}</div>
                                    </td>
                                    <td class="text-right">{{ commaFormat(item.rate) }}</td>
                                    <td class="text-right">{{ commaFormat(item.amount) }}</td>
                                    <td>
                                        <span>
                                            <a v-if="item.pcm_bill_number" href="javascript:void(0)">
                                                <span v-for="(bill, index) in item.pcm_bill_number.split(',')" :key="index">
                                                    {{ bill.trim() }}<br>
                                                </span>
                                                <span class="fw-bold" @click="onCreateNew(item, 'costing')">+ Add More</span>
                                            </a>
                                            <a v-else @click="onCreateNew(item, 'costing')" class="fw-bold" href="javascript:void(0)">+ Costing</a>
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            <a v-if="item.pm_bill_number && item.quantity > item.total_pq" href="javascript:void(0)">
                                                <span v-for="(bill, index) in item.pm_bill_number.split(',')" :key="index">
                                                    {{ bill.trim() }}<br>
                                                </span>
                                                <span class="fw-bold" @click="onCreateNew(item, 'production')">+ Add More</span>
                                            </a>
                                            <a v-else-if="item.pm_bill_number && item.quantity <= item.total_pq" href="javascript:void(0)">
                                                <span v-for="(bill, index) in item.pm_bill_number.split(',')" :key="index">
                                                    {{ bill.trim() }}<br>
                                                </span>
                                            </a>
                                            <a v-else @click="onCreateNew(item, 'production')" class="fw-bold" href="javascript:void(0)">+ Production</a>
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            <a v-if="item.bill_numbers && item.quantity > item.total_del_qty" href="javascript:void(0)">
                                                <span v-for="(bill, index) in item.bill_numbers.split(',')" :key="index">
                                                    {{ bill.trim() }}<br>
                                                </span>
                                                <span class="fw-bold" @click="onCreateNew(item, 'challan')">+ Add More</span>
                                            </a>
                                            <a v-else-if="item.bill_numbers && item.quantity <= item.total_del_qty" href="javascript:void(0)">
                                                <span v-for="(bill, index) in item.bill_numbers.split(',')" :key="index">
                                                    {{ bill.trim() }}<br>
                                                </span>
                                            </a>
                                            <a v-else @click="onCreateNew(item, 'challan')" class="fw-bold" href="javascript:void(0)">+ Challan</a>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="lineItems.length">
                                <tr>
                                    <td colspan="5" class="text-right fw-bold">Subtotal</td>
                                    <td class="text-right fw-bold">{{ commaFormat(totals.total_line_amount) }}</td>
                                    <td colspan="3"></td>
                                </tr>
                            </tfoot>
                        </table>
                        <p v-if="!lineItems.length" class="text-center mt-5">No data</p>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-12">
                <div class="card general-card section-card section-card-activity">
                    <div class="card-body py-1 px-1">
                        <h6 class="card-section-title">Order Activity</h6>
                        <div class="activity-list">
                            <div v-for="(activity, i) in activityFeed" :key="i" class="activity-item">
                                <div class="activity-marker">
                                    <span class="activity-dot"></span>
                                    <span v-if="i !== activityFeed.length - 1" class="activity-line"></span>
                                </div>
                                <div class="activity-content">
                                    <p class="mb-25 fw-bold">{{ activity.title }}</p>
                                    <p class="mb-25 activity-meta">{{ activity.date }} &bull; {{ activity.user_name }}</p>
                                    <a href="javascript:void(0)" class="fw-bold" @click="onClickActivityBill(activity)">{{ activity.bill_number }}</a>
                                </div>
                            </div>
                            <p v-if="!activityFeed.length" class="text-center mt-3">No activity found</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Loader v-if="printing"/>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { taskStatusColors, convertToTitleCase } from '@/services/utils/global.js'
import figureFormatter from '@/services/utils/figureFormatter'
import useDate from '@/services/utils/day'
import handlePurchase from '@/services/modules/purchase'
import handleBarcode from '@/services/modules/barcode'
import handleCompany from '@/services/modules/company'
import piPdfPrint from '@/services/utils/piPdfPrint'
import productCostingPDF from '@/services/utils/pdf/productCosting'
import productionPDF from '@/services/utils/pdf/production'
import POChallanPdfPrinter from '@/services/utils/POChallanPdfPrinter'
import pdfPrinter from '@/services/utils/pdfPrinter'
import orderProductionSummaryPdf from '@/services/utils/pdf/orderProductionSummaryPdf'
import moneyReceiptHelper from '@/services/utils/pdf/moneyReceiptHelper'
import Loader from '@/components/atom/LoaderComponent'

const props = defineProps({
    orderDetail: { type: Object, required: true },
    onCreateNew: { type: Function, required: true }
})

const route = useRoute()
const store = useStore()
const { commaFormat } = figureFormatter()
const { formatToDdMmYy, formatDateTime } = useDate()
const { fetchSalesOrderById, fetchSingleProductCosting, fetchSingleProduction, fetchDeliveryChallan, fetchSalesBill, fetchMoneyReceipt } = handlePurchase()
const { fetchBarcode } = handleBarcode()
const { fetchCompanyInfo, fetchActiveCustomizationField } = handleCompany()
const { exportToPDF: exportOrderPDF } = piPdfPrint()
const { exportToPDF: exportCostingPDF } = productCostingPDF()
const { exportToPDF: exportProductionPDF } = productionPDF()
const { exportToPDF: exportChallanPDF } = POChallanPdfPrinter()
const { exportToPDF: exportSaleInvoicePDF } = pdfPrinter()
const { exportToPDF: exportOrderSummaryPDF } = orderProductionSummaryPdf()
const { generatePdf: generateMoneyReceiptPDF } = moneyReceiptHelper()

const printing = ref(false)
const companyInfo = ref({})
const customizationPdfFields = ref([])

const summary = computed(() => {
    if (!props.orderDetail.order_summary) return {}
    return props.orderDetail.order_summary
})

const lineItems = computed(() => {
    if (!summary.value.line_items) return []
    return summary.value.line_items
})

const totals = computed(() => {
    if (!summary.value.totals) return {}
    return summary.value.totals
})

const contactName = computed(() => {
    if (!summary.value.contact_name) return ''
    return summary.value.contact_name
})

const contactAddress = computed(() => {
    if (summary.value.contact_profile_address) return summary.value.contact_profile_address
    if (!summary.value.contact_address) return ''
    return summary.value.contact_address
})

const kpiTiles = computed(() => {
    return [
        { name: 'Order Qty', value: numberOrZero(totals.value.total_pi_quantity), borderClass: 'border-opening', icon: 'fa-box' },
        { name: 'Production Qty', value: numberOrZero(totals.value.total_production_quantity), borderClass: 'border-debit', icon: 'fa-industry' },
        { name: 'Delivered Qty', value: numberOrZero(totals.value.total_delivered_quantity), borderClass: 'border-credit', icon: 'fa-truck' },
        { name: 'Pending Delivery Qty', value: numberOrZero(totals.value.pending_delivery_quantity), borderClass: 'border-closing', icon: 'fa-hourglass-half' },
        { name: 'Ready for Delivery Qty', value: numberOrZero(totals.value.ready_for_delivery_quantity), borderClass: 'border-ready', icon: 'fa-dolly' },
        { name: 'Pending Production Qty', value: numberOrZero(totals.value.pending_production_quantity), borderClass: 'border-pending', icon: 'fa-cogs' },
        { name: 'Order Value', value: commaFormat(summary.value.total_amount), borderClass: 'border-opening', icon: 'fa-money-bill-wave' },
        { name: 'Delivery Value', value: commaFormat(totals.value.total_delivery_amount), borderClass: 'border-debit', icon: 'fa-truck-loading' },
        { name: 'Paid Amount', value: commaFormat(summary.value.paid_amount), borderClass: 'border-credit', icon: 'fa-hand-holding-usd' },
        { name: 'Due Amount', value: commaFormat(totals.value.due_amount), borderClass: 'border-closing', icon: 'fa-exclamation-circle' }
    ]
})

const activityFeed = computed(() => {
    if (!props.orderDetail.activity) return []
    return props.orderDetail.activity
})

const numberOrZero = (value) => {
    if (!value) return 0
    return value
}

const readableDate = (date) => {
    if (!date) return ''
    return formatToDdMmYy(String(date).split(' ')[0])
}

const badgeStyle = (status) => {
    const color = taskStatusColors[status] || { bg: '#f9fafb', border: '#d1d5db', text: '#111827' }
    return { backgroundColor: color.bg, borderColor: color.border, color: color.text }
}

const companyQuery = () => {
    return `?company_id=${route.params.companyId}`
}

const buildQrCodeQuery = (billNumber, refDate, userName) => {
    const qrcodeData = JSON.stringify({
        ref_no: billNumber,
        ref_date: refDate,
        created_by: userName,
        created_date_time: formatDateTime(new Date())
    })
    return `?code=${billNumber}&qrcode=${qrcodeData}`
}

const loadCompanyInfo = async () => {
    if (companyInfo.value.id) return
    await fetchCompanyInfo(route.params.companyId).then((res) => {
        companyInfo.value = res.data
    })
}

const onClickToPrintSummary = async () => {
    if (!summary.value.id) return
    const user = store.state.user.user
    printing.value = true
    await loadCompanyInfo()

    const barcodeQuery = buildQrCodeQuery(summary.value.bill_number, summary.value.date, user.name)
    await fetchBarcode(barcodeQuery).then((res) => {
        if (!res.status) return
        exportOrderSummaryPDF(companyInfo.value, summary.value, lineItems.value, totals.value, user.name, res.qrcode, activityFeed.value)
    })

    printing.value = false
}

const printOrder = async (activity) => {
    const user = store.state.user.user
    await fetchSalesOrderById(activity.record_id, companyQuery()).then(async (res) => {
        if (!res.data) return
        const invoice = res.data
        const barcodeQuery = buildQrCodeQuery(invoice.bill_number, invoice.date, invoice.created_by_name)
        await fetchBarcode(barcodeQuery).then((res) => {
            if (!res.status) return
            exportOrderPDF(companyInfo.value, invoice, res.barcode, res.qrcode, user.name, 1)
        })
    })
}

const printCosting = async (activity) => {
    const user = store.state.user.user
    await fetchSingleProductCosting(activity.record_id, companyQuery()).then(async ({ status, data }) => {
        if (!status) return
        const barcodeQuery = buildQrCodeQuery(data.bill_number, data.date, user.name)
        await fetchBarcode(barcodeQuery).then((res) => {
            exportCostingPDF(companyInfo.value, data, res.barcode, res.qrcode, user.name)
        })
    })
}

const printProduction = async (activity) => {
    const user = store.state.user.user
    await fetchSingleProduction(activity.record_id, companyQuery()).then(async ({ status, data }) => {
        if (!status) return
        const barcodeQuery = buildQrCodeQuery(data.bill_number, data.production_date, user.name)
        await fetchBarcode(barcodeQuery).then((res) => {
            exportProductionPDF(companyInfo.value, data, res.barcode, res.qrcode, user.name)
        })
    })
}

const loadChallanCustomizationFields = async () => {
    const query = companyQuery() + '&customization_type=pdf&type=delivery_challan_pdf'
    await fetchActiveCustomizationField(query).then((res) => {
        customizationPdfFields.value = res.data
    })
}

const printChallan = async (activity) => {
    const user = store.state.user.user
    await loadChallanCustomizationFields()
    await fetchDeliveryChallan(activity.record_id, companyQuery()).then(async (res) => {
        if (!res) return
        const product = res.data
        const barcodeQuery = buildQrCodeQuery(product.challan_number, product.challan_date, user.name)
        await fetchBarcode(barcodeQuery).then((res) => {
            exportChallanPDF(companyInfo.value, product, res.barcode, res.qrcode, user.name, 1, customizationPdfFields.value)
        })
    })
}

const printSaleInvoice = async (activity) => {
    const user = store.state.user.user
    await fetchSalesBill(activity.record_id, companyQuery()).then(async (res) => {
        if (!res.data) return
        const invoice = res.data
        const barcodeQuery = buildQrCodeQuery(invoice.bill_number, invoice.date, invoice.created_by_name)
        await fetchBarcode(barcodeQuery).then((res) => {
            if (!res.status) return
            exportSaleInvoicePDF(companyInfo.value, invoice, res.barcode, res.qrcode, user.name, 1)
        })
    })
}

const printMoneyReceipt = async (activity) => {
    await fetchMoneyReceipt(activity.record_id, companyQuery()).then((res) => {
        if (!res.status) return
        generateMoneyReceiptPDF(companyInfo.value, res.data)
    })
}

const onClickActivityBill = async (activity) => {
    if (!activity.record_id) return
    printing.value = true
    await loadCompanyInfo()

    if (activity.type === 'order') await printOrder(activity)
    if (activity.type === 'costing') await printCosting(activity)
    if (activity.type === 'production') await printProduction(activity)
    if (activity.type === 'challan') await printChallan(activity)
    if (activity.type === 'sale_invoice') await printSaleInvoice(activity)
    if (activity.type === 'money_receipt') await printMoneyReceipt(activity)

    printing.value = false
}
</script>

<style scoped>
.general-card {
    min-height: auto;
}
.section-card {
    border: 1px solid #d8d6e0;
    border-top: 3px solid #d8d6e0;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(34, 41, 47, 0.08);
}
.section-card-customer {
    border-top-color: #00cfe8;
}
.section-card-items {
    border-top-color: #7367f0;
}
.section-card-activity {
    border-top-color: #28c76f;
}
.card-section-title {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    margin-bottom: 10px;
}
.section-card-customer :deep(p),
.section-card-items :deep(.order-meta-row) {
    font-size: 15px;
}
.order-meta-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}
.meta-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 8px;
    background-color: #f8f8fb;
    border: 1px solid #eeedf2;
}
.meta-chip-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #a5a3ae;
}
.meta-chip-value {
    font-size: 13px;
    font-weight: 600;
    color: #2f2b3d;
}
.meta-divider {
    width: 1px;
    height: 20px;
    background-color: #e5e7eb;
    margin: 0 4px;
}
.stat-tile {
    position: relative;
    height: 100%;
    min-height: 92px;
    padding: 14px 50px 14px 14px;
    border: 1px solid #d8d6e0;
    border-radius: 10px;
    background: linear-gradient(180deg, #fbfbfd 0%, #ffffff 100%);
    box-shadow: 0 2px 10px rgba(34, 41, 47, 0.08);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.stat-tile:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 18px rgba(34, 41, 47, 0.14);
}
.stat-icon-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    background-color: rgba(115, 103, 240, 0.12);
    color: #7367f0;
}
.stat-icon-badge.border-opening {
    background-color: rgba(0, 207, 232, 0.12);
    color: #00cfe8;
}
.stat-icon-badge.border-debit {
    background-color: rgba(115, 103, 240, 0.12);
    color: #7367f0;
}
.stat-icon-badge.border-credit {
    background-color: rgba(40, 199, 111, 0.12);
    color: #28c76f;
}
.stat-icon-badge.border-closing {
    background-color: rgba(234, 84, 85, 0.12);
    color: #ea5455;
}
.stat-icon-badge.border-ready {
    background-color: rgba(255, 159, 67, 0.12);
    color: #ff9f43;
}
.stat-icon-badge.border-pending {
    background-color: rgba(130, 134, 139, 0.12);
    color: #82868b;
}
.stat-label {
    margin-bottom: 6px;
    font-size: 0.92rem;
    font-weight: 600;
    color: #000000;
    letter-spacing: 0.2px;
}
.stat-value {
    margin-bottom: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #2f2b3d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.border-opening {
    border-color: #00cfe8;
}
.border-debit {
    border-color: #7367f0;
}
.border-credit {
    border-color: #28c76f;
}
.border-closing {
    border-color: #ea5455;
}
@media (max-width: 576px) {
    .stat-value {
        font-size: 1.3rem;
    }
    .stat-tile {
        min-height: 80px;
    }
}
.fw-bold {
    font-weight: bold !important;
}
.status-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    border: 1px solid transparent;
    font-size: 12px;
}
.section-card-items :deep(td),
.section-card-items :deep(th) {
    padding: 8px 10px;
    font-size: 13px;
}
.activity-list {
    padding-top: 4px;
    max-height: 520px;
    overflow-y: auto;
}
.activity-item {
    display: flex;
    gap: 12px;
}
.activity-marker {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.activity-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #7367f0;
    flex-shrink: 0;
    margin-top: 4px;
}
.activity-line {
    width: 2px;
    flex: 1;
    background-color: #e5e7eb;
    margin: 4px 0;
}
.activity-content {
    padding-bottom: 16px;
}
.activity-meta {
    font-size: 12px;
    color: #6e6b7b;
}
.summary-row-item{
  padding:5px;
}
</style>
